import { Injectable } from "@angular/core";
import { Subject } from "rxjs";


@Injectable()
export class DeactivateGuardService {

    public navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();
}
